/** Shape returned by every paged dave-service search endpoint. */
export interface PagedResult<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

/** Raw snake_case paged payload as it comes off the wire. */
export interface RawPagedResult<T> {
  items?: T[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
  total_pages?: number;
}

export function normalisePagedResult<T>(
  raw: RawPagedResult<T> | undefined | null,
  fallbackPageNumber = 1,
  fallbackPageSize = 25,
): PagedResult<T> {
  return {
    items: raw?.items ?? [],
    pageNumber: raw?.page_number ?? fallbackPageNumber,
    pageSize: raw?.page_size ?? fallbackPageSize,
    totalCount: raw?.total_count ?? 0,
    totalPages: Math.max(1, raw?.total_pages ?? 1),
  };
}

export interface ApiErrorShape {
  status: number;
  code: string;
  message: string;
  details?: unknown;
}
